import { createGlobalStyle, css } from "styled-components";
import { PAGE_PRINT_MARGIN } from "report/Constants";
const pdfExportTableStyles = ({ $orientation }) => css`
  .table-data-row .table-data-cell,
  .fields-row.message-group td {
    min-width: ${$orientation === "portrait" ? "50px" : "75px"}!important;
    max-width: ${$orientation === "portrait" ? void 0 : "700px"}!important;
  }
`;
const GlobalPDFStyles = createGlobalStyle(
  ({ $orientation, $rootSelector = "html body" }) => css`
    ${$rootSelector} {
      margin-top: 0;
      font-size: 18px;
      ${pdfExportTableStyles({ $orientation })}
    }

    @media print {
      @page {
        margin: ${PAGE_PRINT_MARGIN};
      }
    }
  `
);
export default GlobalPDFStyles;
